import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './api'
import './plugins'
import vuetify from './plugins/vuetify'
import { sync } from 'vuex-router-sync'
import * as VeeValidate from 'vee-validate'
import VueTheMask from 'vue-the-mask'
import IdleVue from 'idle-vue'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
// Components
import './components'

// global helper methods
import './utils/helpers'

import simplebar from 'simplebar-vue'
import 'simplebar/dist/simplebar.min.css'

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

sync(store, router)

Vue.use(VueTheMask)

Vue.use(Viewer)

Vue.use(VeeValidate, { 
  events: 'input|blur',
  inject: false, 
})

const eventsHub = new Vue()

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store: store,
  idleTime: 600000,
  startAtIdle: false,
})

const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common.Authorization = 'Bearer ' + token
}

new Vue({
  router,
  store,
  vuetify,
  simplebar,
  render: h => h(App),
}).$mount('#app')
